import {ICreateObjectData} from '../../common-code/interfaces/createData/ICreateObjectData';

export const searchInCreateObjectData = (createObject: ICreateObjectData, searchText: string): boolean => {
    return searchText.length <= 0 || createObject.title.toLowerCase().includes(searchText.toLowerCase());
}